/*globals $*/
'use strict';

const getValidationFunctions = () => import("./validate");

$( document ).ready(function() {

    $('#hundreds__contact-form #hundreds__contact_submit-button').on('click', function(e){
        console.log('contact');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateContactForm();
        });
    });

    $('#hundreds__newsletter-form #hundreds__newsletter_submit-button').on('click', function(e){
        console.log('newsletter');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateNewsletterForm();
        });
    });

});

